module.exports = __webpack_public_path__ + "img/member-profile.51e49330.svg";